import React, { useState, useRef, useEffect } from 'react';
import { FiSearch, FiExternalLink } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const PLAYLISTS = [
  { id: "4Kn3RZjbkVtpS8UGgH4nNd", title: "2025 mest lyssnade poddavsnitten om digitalisering" },
  { id: "0hfVR958PgRZNAnMqxm72s", title: "Säkerhet" },
  { id: "2B5aRYlRBocAJdvpql1CEZ", title: "Digital Marknadsföring och försäljning - poddavsnitt" },
  { id: "1Z0xH17XX4hglsdSeWN2Jl", title: "Digitalisering Aktuella poddavsnitt" },
  { id: "5OwCTL84umW7HkVzH6yPtq", title: "Digital arbetsplats, digitala samarbeten, Hybridkontoret" },
  { id: "26Dir1p5nDT8DKJYuXs3L6", title: "Metoder inom digitalisering. poddavsnitt" },
  { id: "7Hkm1ur0Nmz1NdoobDaiQf", title: "Microsoft 365 /Office 365 - poddavsnitt" },
  { id: "3k39VtiQd7UcLwIgXUy8Xb", title: "Plattformar digitalisering - poddavsnitt" },
  { id: "2yIHjOuLhFpmLhsMqS1nOK", title: "Tankegods om digitalisering - poddavsnitt" },
  { id: "26lA0tQ64NYrfl0ZLcNfUN", title: "Innovation - poddavsnitt" },
  { id: "2KwabUE3mgQsVJNFfxFxrT", title: "Mjukvarutest - poddavsnitt" },
  { id: "5VWHKDtSaOnXFhgCED1E2u", title: "AI artificiell intelligens - poddavsnitt" }
];

const PlaylistSection = () => {
  const [activeId, setActiveId] = useState(PLAYLISTS[0].id);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTitle, setActiveTitle] = useState(PLAYLISTS[0].title);
  const iframeRef = useRef(null);

  const activePlaylist = PLAYLISTS.find(p => p.id === activeId);

  const filteredPlaylists = PLAYLISTS.filter(p =>
    p.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectPlaylist = (playlist) => {
    setActiveId(playlist.id);
    setActiveTitle(playlist.title);
  };

  return (
    <div className="py-8">
      <h2 className="text-2xl font-bold mb-6 text-gray-900">Spellistor</h2>
      
      <div className="bg-[#0f1115] rounded-2xl p-6 md:p-8">
        <div className="mb-6">
          <h3 className="text-xl md:text-2xl font-bold text-[#f2f4f8] mb-2">
            Effekten – Spellistor
          </h3>
          <p className="text-[#9aa3b2] text-sm md:text-base">
            Poddavsnitt om digitalisering, sorterade efter tema. Välj en lista för att lyssna.
          </p>
        </div>

        <div className="relative mb-6">
          <SafeIcon 
            icon={FiSearch} 
            className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9aa3b2]" 
          />
          <input
            type="search"
            placeholder="Sök spellista…"
            aria-label="Sök spellista"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 rounded-xl border border-[#262a33] bg-[#181b22] text-[#f2f4f8] text-base focus:outline-none focus:ring-2 focus:ring-[#1db954] transition-all"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-6">
          {/* Playlist List */}
          <div className="flex flex-col gap-2 max-h-[60vh] lg:max-h-[75vh] overflow-y-auto pr-2 custom-scrollbar">
            {filteredPlaylists.length === 0 ? (
              <div className="text-[#9aa3b2] p-4 text-sm">
                Inga spellistor matchar.
              </div>
            ) : (
              filteredPlaylists.map((playlist) => (
                <button
                  key={playlist.id}
                  onClick={() => selectPlaylist(playlist)}
                  className={`text-left px-4 py-3 rounded-xl border transition-all duration-150 text-sm font-medium ${
                    activeId === playlist.id
                      ? 'border-[#1db954] bg-[#1a2a20] text-[#f2f4f8]'
                      : 'border-[#262a33] bg-[#181b22] text-[#f2f4f8] hover:border-[#1db954] hover:translate-x-1'
                  }`}
                >
                  {playlist.title}
                </button>
              ))
            )}
          </div>

          {/* Player */}
          <div className="lg:sticky lg:top-6 bg-[#181b22] border border-[#262a33] rounded-2xl p-4 md:p-6">
            <h4 className="text-base md:text-lg font-semibold text-[#f2f4f8] mb-4 line-clamp-2">
              {activeTitle}
            </h4>
            <iframe
              ref={iframeRef}
              src={`https://open.spotify.com/embed/playlist/${activeId}?utm_source=generator&theme=0`}
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              title="Spotify-spelare"
              className="w-full h-[380px] md:h-[480px] rounded-xl border-0"
            />
            <a
              href={`https://open.spotify.com/playlist/${activeId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 text-[#1db954] text-sm font-medium hover:underline"
            >
              <span>Öppna i Spotify</span>
              <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #181b22;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #262a33;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #1db954;
        }
      `}</style>
    </div>
  );
};

export default PlaylistSection;